import { useMemo, type ReactElement } from 'react';
import { generatePath, useParams } from 'react-router-dom';
import { usePageBreadcrumb, usePageSidebar, useStrapiApi, useStrapiParams } from '@/hooks';
import { sidebarItems } from '../sidebar';
import { ROUTES } from '@/constants';
import type { Category, Post, StrapiListRequest, StrapiResponse } from '@/interfaces/strapi';
import { getCategory, getPostBySlug } from '@/services/strapi';
import { PostDetail } from '@/components';

export const Articulo = (): ReactElement => {
	const { category: categorySlug, post: postSlug } = useParams<{ category: string; post: string }>();

	const catParams = useStrapiParams({
		page: 1,
		pageSize: 1,
		sort: 'id:desc',
		additionalFilters: categorySlug ? { slug: { $eq: categorySlug }, active: true } : { active: true },
	});

	const { data: categoryResponse, loading: loadingCat } = useStrapiApi<StrapiResponse<Category>, StrapiListRequest>(
		getCategory,
		{
			autoFetch: true,
			params: catParams,
		},
	);
	const category = categoryResponse?.data;

	const postsParams = useStrapiParams({
		sort: 'publishedAt:desc',
		additionalFilters: postSlug ? { slug: { $eq: postSlug } } : undefined,
		populate: {
			image: true,
			file: true,
			web_categorias_noticia: true,
		},
	});

	const { data: postResponse, loading: loadingPosts } = useStrapiApi<StrapiResponse<Post>, StrapiListRequest>(
		getPostBySlug,
		{
			autoFetch: true,
			params: postsParams,
		},
	);

	const post = postResponse?.data;

	usePageBreadcrumb([
		{ label: 'Actualidad', to: ROUTES.ACTUALIDAD },
		{
			label: category?.name ?? '',
			to: generatePath(ROUTES.ACTUALIDAD_BY_CATEGORY, {
				category: categorySlug,
			}),
		},
	]);

	const sidebar = useMemo(() => sidebarItems, []);
	usePageSidebar(sidebar, true);

	return (
		<div>
			{loadingCat || loadingPosts ? (
				<p>Cargando…</p>
			) : (
				post && <PostDetail categorySlug={categorySlug ?? ''} item={post} />
			)}
		</div>
	);
};
